import { render, staticRenderFns } from "./CardGaleries.vue?vue&type=template&id=5d4cf6cd&"
import script from "./CardGaleries.vue?vue&type=script&lang=js&"
export * from "./CardGaleries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports